import { useState, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import AlertMessage from "../../../components/Alert";
import { Load } from "../../../components/Load";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Tooltip, Grid } from '@mui/material';
import InputMask from 'react-input-mask';
import PaymentConfirmationModal from "../ModalAsoPagamento";
import { DocumentoEmpresa } from "../DocumentoEmpresa";
import { io } from "socket.io-client";

const ReaproveitamentoAsoPagamentoTrabalhador = () => {
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [isLoading, setIsLoading] = useState(false);
    const { trabalhadorId, funcaoId } = useParams();
    const navigate = useNavigate();
    const [exames, setExames] = useState([]);
    const [progressMessage, setProgressMessage] = useState('');
    const [progressIcon, setProgressIcon] = useState<any>(null);
    const [valorInicialTotal, setValorInicialTotal] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [qrCode, setQrCode] = useState('');
    const [riscos, setRiscos] = useState([]);
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [paymentApproved, setPaymentApproved] = useState(false);
    const [descontoTotal, setDescontoTotal] = useState(false);
    const [trabalhadorSelecionado, setTrabalhadorSelecionado] = useState({});
    const [funcaoSelecionada, setFuncaoSelecionada] = useState({});
    const [progressValue, setProgressValue] = useState(0);
    const [redirectCounter, setRedirectCounter] = useState(3);

    const fetchExams = async () => {
        try {
            const response = await api.get(`buscar-dados-aso-pronto/${trabalhadorId}/${funcaoId}`)
            const responseData = response.data;
            setExames(responseData.examesTrabalhadorAtual);
            setRiscos(responseData.riscosFuncao);
        } catch (error) {
            console.error(error);
        }
    }

    const fetchTrabalhador = async () => {
        try {
            const response = await api.get(`trabalhadores/listar/${trabalhadorId}`)
            const responseData = response.data.data;
            setTrabalhadorSelecionado(responseData.trabalhador);
        } catch (error) {
            console.error(error);
        }       
    }

    const fetchFuncao = async () => {
        try {
            const response = await api.get(`buscar-funcao-por-id/${funcaoId}`)
            setFuncaoSelecionada(response.data);
        } catch (error) {
            console.error(error);
        }       
    }
    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    function handleClose(){
        setShowModal(false);
    }

    
    function handleOpenPdf() {
        setOpenPdfModal(true)
    }

    function handleClosePdf() {
        setOpenPdfModal(false)
    }

    async function handlePayment() {
        try {
            let focusSet = false;

            // Verifica se algum dos campos obrigatórios está vazio
            if (!funcaoId) {
                if (!focusSet) {
                    const input = document.getElementById('funcaoSelecionada') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            } 

            // Se algum campo estava vazio, exibe um alerta geral e sai da função
            if (!funcaoId) {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro inesperado, por favor entre em contato com o responsavel.",
                    variant: "warning",
                });
                return;
            }

            const paymentDetails = {
                transaction_value: valorInicialTotal,
                description: 'Reaproveitamento de ASO Pronto pagamento pelo trabalhador.',
                email: 'comercial@medicoatento.com.br', //TODO: Alterar o email para gerar pagamento
                cpf: 'xxx.xxx.xxx-xx',
            };
            const response = await api.post('/pix/create', paymentDetails);
            setQrCode(response.data.qr_code_base64);
            setShowModal(true);

        } catch (error) {
            console.error('Erro ao criar pagamento PIX:', error);
        }
    };

    const handleSavePayment = async (data: any, userId: any) => {
        try {
            data.userId = userId;
            await api.post('salvar-pagamento-reaproveitamento', data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const calcularValorInicial = () => {
            const somaValores = parseFloat(exames
                .reduce((total: number, exame: { valor_total: number }) => total + exame.valor_total / 100, 0)
                .toFixed(2));
            setValorInicialTotal(somaValores);
        };

        // Apenas calcula o valor inicial na primeira carga
        if (exames.length > 0 && valorInicialTotal === 0) {
            calcularValorInicial();
        }
    }, [exames]);

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            window.history.pushState(null, "", window.location.pathname);
        };

        const loop = () => {
            window.history.pushState(null, "", window.location.pathname);
            setTimeout(loop, 100);
        };

        window.history.pushState(null, "", window.location.pathname);
        window.addEventListener('popstate', handlePopState);

        loop();

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
    
    useEffect(() => {
        fetchExams();
        fetchFuncao();
        fetchTrabalhador();
    }, []);


    useEffect(() => {
        const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, { transports: ['websocket', 'polling'] });

        socket.on('paymentStatusUpdated', (data: any) => {
            if (data.status === 'approved') {
                setPaymentApproved(true);
                handleSavePayment(data, trabalhadorId);
            }
        });

        return () => {
            socket.off('paymentStatusUpdated');
        };
    }, []);

    useEffect(() => {
        if (paymentApproved) {
            const progressTimer = setInterval(() => {
                setProgressValue((oldValue) => {
                    const newValue = oldValue + 1;
                    if (newValue === 100) {
                        clearInterval(progressTimer);
                        const redirectTimer = setInterval(() => {
                            setRedirectCounter((counter) => {
                                if (counter === 1) {
                                    clearInterval(redirectTimer);
                                    handleOpenPdf();
                                }
                                return counter - 1;
                            });
                        }, 1000);
                    }
                    return newValue;
                });
            }, 100);
        }
    }, [paymentApproved]);


    return (
        <>
            {isLoading ? (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <div className="progress-container">
                            <div className="progress-icon">
                                {progressIcon}
                            </div>
                            <div className="progress-message">
                                {progressMessage}
                            </div>
                            <div className="progress-bar" style={{ width: `${progressValue}%` }} />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className='background background-vi-desktop background-mobile'>
                        <div className='container' style={{ maxWidth: '700px' }}>                          
                            <Card style={{ width: "100%" }}>
                                <Card.Body className='card-body-vi-desktop card-body-mobile'>
                                    <Card.Title style={{ textAlign: 'center', padding: '10px', fontSize: '22px', fontWeight: '600', marginBottom: '0' }}>
                                        Pagamento de Exames do ASO
                                    </Card.Title>
                                    <Card.Text style={{ textAlign: 'center', padding: '10px', fontSize: '14px' }}>
                                        Pague os seguintes exames para liberar o reaproveitamento.
                                    </Card.Text>
                                    <Row>
                                        <Col xs={12} md={12} xl={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            <Row style={{ marginTop: '10px' }}>
                                                <h6 style={{ color: '#808080', textAlign: 'center' }}>Exames Incluídos</h6>
                                            </Row>
                                            <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                                <table >
                                                    <thead>
                                                        <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                            <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                            <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Exame</th>
                                                            <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Valor</th>
                                                        
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {exames.map((exame: any, index: number) => {
                                                            return (
                                                                <tr key={exame.id}>
                                                                    <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                        <div>{index + 1}</div>
                                                                    </td>
                                                                    <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                        {exame.ateBaseExames.nome}
                                                                    </td>
                                                                    <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                        {transformarPreco(exame.valor_total)}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className="mt-3">
                                    
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button variant='primary' onClick={handlePayment}>Pagar Reaproveitamento ASO</Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>

                    {openPdfModal && (
                        <DocumentoEmpresa
                            trabalhadorSelecionado={trabalhadorSelecionado}
                            funcaoSelecionada={funcaoSelecionada}
                            riscosIncluidos={riscos}
                            examesCadastrados={exames}
                            descontoTotal={descontoTotal}
                            valorInicialTotal={valorInicialTotal}
                            onClose={handleClosePdf}
                            isAsoPronto={true}
                        />
                    )}

                    <PaymentConfirmationModal 
                        show={showModal} 
                        handleClose={handleClose}
                        paymentApproved={paymentApproved}
                        progressValue={progressValue}
                        descontoTotal={descontoTotal}
                        valorInicialTotal={valorInicialTotal}
                        qrCode={qrCode}
                    />
                            
                    <AlertMessage
                        show={alert.show}
                        message={alert.message}
                        variant={alert.variant}
                        onClose={() => setAlert({ ...alert, show: false })}
                    />
                </>
            )}
        </>
    );
};

export default ReaproveitamentoAsoPagamentoTrabalhador;
